<template>
  <div>transferIn</div>
</template>
<script type="text/javascript">
export default {
  name: 'TransferIn'
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/ChangeBusiness/TransferIn.vue